import React from "react";
import SkillCSS from "../../../style/helperCSS/Skill.module.css";

const Skill = ({ images }) => {
  return (
    <div className={`row ${SkillCSS.skill_row}`}>
      {Object.keys(images).map((key) => (
        <div className={`col-md-2 col-4 ${SkillCSS.skill_div}`} key={key}>
          <div className={`${SkillCSS.img_div}`}>
            <img src={images[key]} alt="Skill image" />
            <h6>{key}</h6>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Skill;
